<header class="usa-header usa-header--extended" role="banner">
    <div class="usa-navbar">
      <div class="usa-logo" id="extended-logo">
    <span><a href="https://www.section508.gov/">
      <img class="logo" alt="Section508.gov Home; GSA logo with text: Section508.gov Buy. Build. Be Accessible." integrity="sha512-S2YGUVu8KqAmjqtxiMVq5MXieFg+L8T4y7Uv3eHZE3ePWZbUSJnehCZbsNEDiG/ZcFGxms61gqe9YViO6H/KZQ==" crossorigin="anonymous" src="{{url}}/assets/images/508-logo-cropped-web-altgreen.png">
    </a></span>
  </div>
  
      <button class="usa-menu-btn">Menu</button>
    </div>
    <nav role="navigation" class="usa-nav" aria-label="Primary Site Navigation">
      <div class="usa-nav__inner">
        <button class="usa-nav__close"><img alt="close" integrity="sha512-XLawNnedFKdaFdJhoad/TAQHLO1XHwSyvZVlVpXieNmk80S974//1mU5khr0OXVTGH4H3k6mTs9tVP/J6fPoFw==" crossorigin="anonymous" src="{{url}}/assets/uswds/img/usa-icons/close.svg"></button>
        <ul class="usa-nav__primary usa-accordion">
          
          
          
          
          <li class="usa-nav__primary-item">
            <a aria-label="Policy &amp; Management primary navigation" class="usa-nav__link" href="https://www.section508.gov/manage/"><span>Policy &amp; Management</span></a>
          </li>
          
          
          
          
          
          <li class="usa-nav__primary-item">
            <a aria-label="Acquisition primary navigation" class="usa-nav__link" href="https://www.section508.gov/buy-sell/"><span>Acquisition</span></a>
          </li>
          
          
          
          
          
          <li class="usa-nav__primary-item">
            <a aria-label="Content Creation primary navigation" class="usa-nav__link" href="https://www.section508.gov/create/"><span>Content Creation</span></a>
          </li>
          
          
          
          
          
          <li class="usa-nav__primary-item">
            <a aria-label="Design &amp; Develop primary navigation" class="usa-nav__link" href="https://www.section508.gov/develop/"><span>Design &amp; Develop</span></a>
          </li>
          
          
          
          
          
          <li class="usa-nav__primary-item">
            <a aria-label="Testing primary navigation" class="usa-nav__link" href="https://www.section508.gov/test/"><span>Testing</span></a>
          </li>
          
          
          
          
          
          <li class="usa-nav__primary-item">
            <a aria-label="Training, Tools &amp; Events primary navigation" class="usa-nav__link" href="https://www.section508.gov/training/"><span>Training, Tools &amp; Events</span></a>
          </li>
          
          
        </ul>
        <div class="usa-nav__secondary">
          <ul class="usa-nav__secondary-links">
            
            <li class="usa-nav__secondary-item">
              <a href="https://www.section508.gov/blog/">Blogs &amp; Updates</a>
            </li>
            
            <li class="usa-nav__secondary-item">
              <a href="https://www.section508.gov/tools/coordinator-listing/">My Agency’s 508 PM</a>
            </li>
            
            <li class="usa-nav__secondary-item">
              <a href="https://www.section508.gov/about-us/">About Us</a>
            </li>
            
          </ul>
          
  
  
    
      <form id="search_form" class="usa-search usa-search--small" action="https://search.usa.gov/search" accept-charset="UTF-8" method="get">
    
      
    
      <input name="utf8" type="hidden" value="✓">
      <input name="affiliate" type="hidden" value="gsa-section508-accessibility">
    
      <div role="search">
        <label class="usa-sr-only" for="extended-search-field-small">Search small</label>
        <input class="usa-input usagov-search-autocomplete" id="extended-search-field-small" type="search" name="query" autocomplete="off">
        <button class="usa-button primary-background-color" type="submit"><img src="{{url}}/assets/icons/search-white.svg" class="usa-search__submit-icon" alt="Search"></button>
      </div>
    </form>
  
  
        </div>
      </div>
    </nav>
  </header>